import { languageCodeToName } from 'js/lib/language';

export function getLanguageString(languagesArray: Array<string>) {
  return languagesArray.map(languageCodeToName).join(', ');
}
